import type { CALL_MODE, CALL_STATUS } from '@/constants';
import { createListStoreWithQuery } from '@/store/list-state.factory';

export type CallStatusValue = 'All' | (typeof CALL_STATUS)[number]['value'];
export type CallModeValue = 'All' | (typeof CALL_MODE)[number]['value'];

export type Filters = {
  status: CallStatusValue;
  mode: CallModeValue;
};

export const useCallsListStore = createListStoreWithQuery('calls-list-state', {
  filterDefaults: {
    status: 'All' as CallStatusValue,
    mode: 'All' as CallModeValue,
  },
});
